import {useCallback} from "react";
import {Manifest, SearchableSortDirection} from "../../../../generated/graphql";
import {DragAndDropTargetPayload, AssignmentViewActionTypes} from "../../../../providers/AssignmentViewReducer";
import ManifestDriverList from "./ManifestDriverList";
import DispatchRulesDataProvider from "../../../../providers/DispatchRulesDataProvider";
import {JobTypes} from "../../../settings/ColorSettings/ColorizedIndicators/types/jobTypeSelectorValues";
import {TManifestDetailsDrawerOpen} from "../../../../views/UnassignedJobsView";
import {useAssignmentDispatch, useAssignmentState} from "../../../../providers/AssignmentProdiver";
import {useAssignmentViewDispatch} from "../../../../providers/AssignmentViewProvider";
import {useMapVisibilityDispatch, useMapVisibilityState} from "../../../map/MapVisibilityContext";
import {TManifestEnhanced} from "../../../common/types";

type ManifestViewSelectorProps = {
  selectedManifest?: TManifestEnhanced;
  disabledManifestIds: number[];
  data: TManifestEnhanced[];
  isManifestDetailsDrawerOpen: boolean;
  onManifestDetailsDrawerOpen: TManifestDetailsDrawerOpen;
  sortByColor?: {
    enable: boolean;
    direction: SearchableSortDirection;
  };
};

const ManifestViewSelector = ({
  selectedManifest,
  disabledManifestIds,
  data,
  isManifestDetailsDrawerOpen,
  onManifestDetailsDrawerOpen,
  sortByColor
}: ManifestViewSelectorProps) => {
  const {pendingActions} = useAssignmentState();
  const assignmentStateDispatch = useAssignmentDispatch();
  const assignmentViewStateDispatch = useAssignmentViewDispatch();
  const mapVisibilityState = useMapVisibilityState();
  const mapVisibilityDispatch = useMapVisibilityDispatch();

  const handleOnSelectedManifest = useCallback(
    (manifest: TManifestEnhanced) => {
      assignmentStateDispatch({type: "SetSelectedManifest", payload: manifest});
    },
    [assignmentStateDispatch]
  );

  const handleUpdateDropTargets = useCallback((dragAndDropPayload: DragAndDropTargetPayload[]) => {
    assignmentViewStateDispatch({
      type: AssignmentViewActionTypes.SET_DRAG_AND_DROP_TARGETS,
      payload: dragAndDropPayload
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnDrillDownManifest = useCallback(
    (manifest: Manifest) => {
      onManifestDetailsDrawerOpen(manifest.manifestDriverId, manifest.driver.driverId);
    },
    [onManifestDetailsDrawerOpen]
  );

  const handleLocationMarkerClicked = useCallback((manifest: Manifest) => {
    mapVisibilityDispatch({type: "IncrementManifestVisibility", manifest: manifest});
    mapVisibilityDispatch({type: "SetIsViewGestured", payload: false});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <DispatchRulesDataProvider jobType={JobTypes.AssignedStops}>
      <ManifestDriverList
        isManifestDetailsDrawerOpen={isManifestDetailsDrawerOpen}
        data={data}
        selectedManifest={selectedManifest}
        disabledManifestIds={disabledManifestIds}
        onSelectedManifest={handleOnSelectedManifest}
        onDrillDownManifest={handleOnDrillDownManifest}
        handleUpdateDropTargets={handleUpdateDropTargets}
        pendingActions={pendingActions}
        visibleManifests={mapVisibilityState.manifests}
        onLocationMarkerClick={handleLocationMarkerClicked}
        sortByColor={sortByColor}
      />
    </DispatchRulesDataProvider>
  );
};

export default ManifestViewSelector;
